import { render, staticRenderFns } from "./MiniAppRuiDiTuiActivityPromoters.vue?vue&type=template&id=69137269&scoped=true&"
import script from "./MiniAppRuiDiTuiActivityPromoters.vue?vue&type=script&lang=js&"
export * from "./MiniAppRuiDiTuiActivityPromoters.vue?vue&type=script&lang=js&"
import style0 from "./MiniAppRuiDiTuiActivityPromoters.vue?vue&type=style&index=0&id=69137269&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69137269",
  null
  
)

export default component.exports